export default __webpack_public_path__ + "static/signature.1.0.0-white-2b547e7abe5efa16a9d2dc55e74623e7.png";